import ACTIONS from "./types";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";
import Axios from "axios";
import { has } from "lodash";

export const setManiView = (tab) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICES.SET_MAIN_VIEW,
    payload: tab,
  });
};
export const setViewMode = (mode) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICES.SET_VIEW_MODE,
    payload: mode,
  });
};

export const fetchAllServiceCenters =
  (queryParams = "") =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.SERVICES.FETCH_ALSERVICE_CENTERER_START,
    });
    return Axios.get(`${API_ENDPOINTS.SERVICE_CENTERS}?${queryParams}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_ALL_SERVICE_CENTER_SUCCESS,
          payload: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_ALL_SERVICE_CENTER_FAILURE,
          payload: err,
        });
        return false;
      });
  };

export const fetchAllServiceOrders =
  (queryParams = "", page = 1, limit = 25) =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_START,
    });
    const separator = queryParams.length > 0 ? "&" : "";
    return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}?${queryParams}${separator}page=${page}&limit=${limit}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST,
          payload: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_FAILURE,
          payload: err,
        });
        return false;
      });
  };

export const fetchServiceOrderDetails = (orderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const fetchAllServiceOrderSolutions = () => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/solutions`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST_LIST_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const createNewServiceCenter =
  ({ name, geo, users }) =>
  (dispatch) => {
    return Axios.post(`${API_ENDPOINTS.SERVICE_CENTERS}`, {
      name: name,
      geo: geo,
      users: users.map((user) => user._id),
    })
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.ADD_NEW_SUCCESS,
          payload: res.data,
          // payload: res,
        });
        fetchAllServiceCenters("")(dispatch);
        // _getInt_selectedClientDevices(
        //   selectedIntSystem,
        //   selectedorganization,
        //   dispatch
        // );
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.ADD_NEW_FAILURE,
          payload: err,
        });
        return err;
      });
  };

export const getSpecificServiceCenter = (serviceCenterId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTERER_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenterId}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTER_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTER_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const getServiceCenterTechnicians =
  (serviceCenterId, queryParams = "") =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_START,
    });
    return Axios.get(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenterId}/technicians?${queryParams}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_SUCCESS,
          payload: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_FAILURE,
          payload: err,
        });
        return false;
      });
  };

export const setSelectedTechnician = (serviceCenterId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICES.SET_SELECTED_TECHNICIAN,
    payload: serviceCenterId,
  });
};

export const removeTechnicianFromCenter = (selectedTechnician, serviceCenter) => (dispatch) => {
  if ((selectedTechnician, serviceCenter)) {
    dispatch({
      type: ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER_START,
    });
    return Axios.delete(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenter._id}/technicians/${selectedTechnician.technician._id}`)
      .then(() => {
        return dispatch({
          type: ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER,
          payload: {
            selectedTechnician,
            serviceCenter,
          },
        });
      })
      .catch((err) => {
        return dispatch({
          type: ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER_FALURE,
          payload: err,
        });
      });
  }
};

export const deactivateTechnician = (selectedTechnician, serviceCenter) => (dispatch) => {
  if ((selectedTechnician, serviceCenter)) {
    dispatch({
      type: ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER_START,
    });
    return Axios.patch(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenter._id}/technicians/${selectedTechnician.technician._id}`, {
      isActive: false,
    })
      .then(() => {
        dispatch({
          type: ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER,
          payload: {
            selectedTechnician,
            serviceCenter,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER_FALURE,
          payload: err,
        });
      });
  }
};

export const updateServiceCenter = (serviceCenterData) => (dispatch) => {
  if (serviceCenterData) {
    dispatch({
      type: ACTIONS.SERVICES.UPDATE_SERVICE_CENTER_START,
    });
    return Axios.patch(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenterData._id}`, {
      ...serviceCenterData,
    })
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.UPDATE_SERVICE_CENTER,
          payload: res.data,
        });
        getServiceCenterTechnicians(res.data.serviceCenter._id)(dispatch);
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.UPDATE_SERVICE_CENTER_FALURE,
          payload: err,
        });
      });
  }
};

export const deleteServiceCenter = (serviceCenter) => (dispatch) => {
  if (serviceCenter) {
    dispatch({
      type: ACTIONS.SERVICES.DELETE_SERVICE_CENTER_START,
    });
    return Axios.delete(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenter._id}`)
      .then(() => {
        dispatch({
          type: ACTIONS.SERVICES.DELETE_SERVICE_CENTER,
          payload: {
            serviceCenter,
          },
        });
        fetchAllServiceCenters()(dispatch);
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.DELETE_SERVICE_CENTER_FALURE,
          payload: err,
        });
      });
  }
};

export const createNewTechnicianWithModels = (selectedUser, serviceCenters, selectedTypesAndModels) => (dispatch) => {
  if (selectedUser && serviceCenters) {
    dispatch({
      type: ACTIONS.SERVICES.CREATE_TECHNICIAN_START,
    });
    return Axios.post(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenters._id}/technicians`, {
      userId: selectedUser._id,
    })
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.CREATE_TECHNICIAN,
          payload: { ...res.data, ...selectedUser },
        });
        getServiceCenterTechnicians(res.data.serviceCenter._id)(dispatch);
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.CREATE_TECHNICIAN_FALURE,
          payload: err,
        });
      });
  }
};

export const getTechnicianDetails = (technicianId, serviceCenterId) => (dispatch) => {
  if (technicianId && serviceCenterId) {
    dispatch({
      type: ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS_START,
    });
    return Axios.get(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenterId}/technicians/${technicianId}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS,
          payload: { ...res.data },
        });
        getServiceCenterTechnicians(res.data.serviceCenter._id)(dispatch);
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS_FALURE,
          payload: err,
        });
      });
  }
};

export const editTechnicians = (serviceCenterId, selectedTechnicianData) => (dispatch) => {
  if (serviceCenterId && selectedTechnicianData && has(selectedTechnicianData, "_id")) {
    dispatch({
      type: ACTIONS.SERVICES.EDIT_TECHNICIAN_START,
    });
    return Axios.patch(`${API_ENDPOINTS.SERVICE_CENTERS}/${serviceCenterId}/technicians/${selectedTechnicianData._id}`, {
      userId: selectedTechnicianData._id,
      ...selectedTechnicianData,
    })
      .then((res) => {
        getServiceCenterTechnicians(res.data.serviceCenter._id)(dispatch);
        return dispatch({
          type: ACTIONS.SERVICES.EDIT_TECHNICIAN,
          payload: { ...res.data, ...selectedTechnicianData },
        });
      })
      .catch((err) => {
        return dispatch({
          type: ACTIONS.SERVICES.EDIT_TECHNICIAN_FALURE,
          payload: err,
        });
      });
  }
};

export const AddOrEditServicesOrder = (orderData) => (dispatch) => {
  if (orderData) {
    dispatch({
      type: ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER_START,
    });
    return Axios.post(`${API_ENDPOINTS.SERVICE_ORDERS}`, {
      service_center: orderData.service_center,
      service_issue: orderData.service_issue,
      technician: orderData.technician,
      dueDate: orderData.dueDate,
      device: orderData.device,
      owner: orderData.owner,
      notes: orderData.note,
    })
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER_FAILURE,
          payload: err,
        });
      });
  }
};

export const setServiceOrderWizardStep = (serviceOrder, step) => (dispatch) => {
  if (serviceOrder && "_id" in serviceOrder) {
    return Axios.patch(`${API_ENDPOINTS.SERVICE_ORDERS}/${serviceOrder._id}`, {
      activeWizardStep: step,
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const finishServiceOrder = (orderData) => (dispatch) => {
  const baseUrl = `${API_ENDPOINTS.SERVICE_ORDERS}/${orderData._id}/finish`;
  const body = {
    ...orderData,
  };
  return Axios.patch(baseUrl, body);
};

export const editServicesOrderData = (orderData, isFinish) => (dispatch) => {
  if (orderData && "_id" in orderData && orderData._id) {
    dispatch({
      type: ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA_START,
    });
    return Axios.patch(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderData._id}${isFinish ? "/finish" : ""}`, {
      ...orderData,
    })
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA,
          payload: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA_FAILURE,
          payload: err,
        });
      });
  }
};

export const addServicesOrderAttachments = (orderId, attachment) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT_START,
  });
  return Axios.post(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}/attachments`, attachment)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT_FAILURE,
      });
      return err;
    });
};

export const fetchAllServicesOrders =
  (queryParams = "") =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_START,
    });
    return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}?${queryParams}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST,
          payload: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_FAILURE,
          payload: err,
        });
        return false;
      });
  };

export const fetchAllSeviceOrderAttachments = (orderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}/attachments`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_ALL_SEVICE_ORDER_ATTACHMENTS,
        payload: res.data,
      });

      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const getDeviceServiceOrderAttachmentsList = (selectedServiceOrderDetails) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/${selectedServiceOrderDetails._id}/attachments`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_FAILURE,
        payload: err,
      });
    });
};

export const uploadFileToServiceOrder = (attachment, selectedServiceOrderDetails) => (dispatch) => {
  return Axios.post(`${API_ENDPOINTS.SERVICE_ORDERS}/${selectedServiceOrderDetails._id}/attachments`, attachment)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteServiceOrderAttachments = (selectedServiceOrderDetails, attachment) => (dispatch) => {
  return Axios.delete(`${API_ENDPOINTS.SERVICE_ORDERS}/${selectedServiceOrderDetails._id}/attachments/${attachment._id}`)
    .then((res) => res)
    .catch((err) => err);
};
export const getServiceOrderStatuses = () => (dispatch) => {
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/statuses`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const deleteServiceOrder = (selectedServiceOrderDetails) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_START,
  });
  return Axios.delete(`${API_ENDPOINTS.SERVICE_ORDERS}/${selectedServiceOrderDetails._id}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER,
        payload: selectedServiceOrderDetails,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_FAILURE,
      });
    });
};
export const archiveServiceOrder = (selectedServiceOrderDetails) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_START,
  });
  return Axios.patch(`${API_ENDPOINTS.SERVICE_ORDERS}/${selectedServiceOrderDetails._id}/archive`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER,
        payload: selectedServiceOrderDetails,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_FAILURE,
      });
    });
};

export const getServicesOrderDetails = (orderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS,
        payload: res.data,
      });

      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const onSetServiceOrderActiveStep = (activeStep) => (dispatch) => {
  if (activeStep) {
    dispatch({
      type: ACTIONS.SERVICE_ORDERS.SET_SERVICE_ORDER_ACTIVE_STEP,
      payload: activeStep,
    });
  }
};

export const onSubmitBeforeImageAttachment = (beforeImageData, orderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_START,
  });
  return Axios.put(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}/images/before-images`, beforeImageData)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_FAILURE,
        payload: err,
      });
      return {
        message: err,
      };
    });
};

export const deleteBeforeImageByIdFromServiceOrder = (serviceOrderId, beforeImageId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.DELETE_BEFORE_IMAGE,
    payload: { beforeImageId },
  });
  return Axios.delete(`${API_ENDPOINTS.SERVICE_ORDERS}/${serviceOrderId}/images/before-image/${beforeImageId}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error(err);
    });
};

export const onSubmitAfterImageAttachment = (afterImageData, orderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_START,
  });
  return Axios.put(`${API_ENDPOINTS.SERVICE_ORDERS}/${orderId}/images/after-images`, afterImageData)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_FAILURE,
        payload: err,
      });
      return {
        message: err,
      };
    });
};

export const setTargetReplacementDevice = (targetDevice) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.SET_TARGET_REPLACEMENT_DEVICE,
    payload: targetDevice,
  });
};

export const replaceWithDeviceById = (details, sourceDevice, newGeo) => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS_START,
  });

  return Axios.patch(`${API_ENDPOINTS.DEVICES}/${sourceDevice._id}`, { ...sourceDevice, geo: newGeo }).then((res) => {
    return Axios.post(`${API_ENDPOINTS.TASKS}`, { taskType: "DEVICE_REPLACEMENT", details })
      .then((res) => {
        if (res.status === 200)
          dispatch({
            type: ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS,
          });
        if (res.data.error) {
          return {
            message: res.data.error,
            status: 444,
          };
        } else {
          return {
            message: null,
            status: res.status,
          };
        }
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS_FAILURE,
          payload: err,
        });
        return err.response.status;
      });
  });
};
export const getServiceCauses = () => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES_START,
  });
  return Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/service-causes`)
    .then((res) => {
      if (res.status === 200)
        dispatch({
          type: ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES,
          payload: res.data,
        });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES_FAILURE,
        payload: err,
      });
      return {
        message: err,
      };
    });
};

export const filterServicceOrdersList = (list, query) => (dispatch) => {
  return list.filter((item) => {
    return (
      item.technician?.user?.name?.toLowerCase().includes(query) ||
      item.device?.name?.toLowerCase().includes(query) ||
      item.service_center?.name?.toLowerCase().includes(query) ||
      item.device?.device?.toLowerCase().includes(query) ||
      item.status?.name?.toLowerCase().includes(query) ||
      item.owner?.name?.toLowerCase().includes(query) ||
      item.service_issue?.name?.toLowerCase().includes(query) ||
      item.created_at?.toLowerCase().includes(query)
    );
  });
};

export const fetchAllServiceOrdersOwners = () => (dispatch) => {
  dispatch({
    type: ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_START,
  });
  Axios.get(`${API_ENDPOINTS.SERVICE_ORDERS}/owners`)
    .then((res) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_SUCCESS,
        payload: [...res.data],
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_FAILURE,
        payload: err,
      });
    });
};

export const fetchAllTechnicians = () => (dispatch) => {
  dispatch({ type: ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_START });
  Axios.get(API_ENDPOINTS.TECHNICIANS)
    .then((res) => {
      dispatch({ type: ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_SUCCESS, payload: res.data });
      return res.data;
    })
    .catch((err) => {
      dispatch({ type: ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_FAILURE, payload: err });
    });
};
